import { render, staticRenderFns } from "./CopySkillQuestions.vue?vue&type=template&id=5409e110"
import script from "./CopySkillQuestions.vue?vue&type=script&lang=js"
export * from "./CopySkillQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports